export const GOOGLE_ANALYTICS_PARAM_NAMES = {
    CLICK: 'click',
    // dataLayer params
    GT_USER_ID: 'user_id',
    GT_SEND_CURRENCY: 'send-currency',
    GT_AMOUNT_SEND_CURRENCY: 'amount-send-currency',
    GT_SENDING_COUNTRY_CODE: 'sending-country-code',
    GT_RECEIVING_COUNTRY_CODE: 'receiving-country-code',
    GT_TRX_ID: 'trx-id',
    GT_SENDER_BALID: 'sender_balID',
    GT_TRANSACTION_ID: 'transaction_ID',
    GT_RECEIVING_COUNTRY: 'receiving_country',
    GT_SECTION_CLICKED: 'section_clicked',
} as const;

export type GoogleAnalyticsParamNameKey = keyof typeof GOOGLE_ANALYTICS_PARAM_NAMES;
export type GoogleAnalyticsParamNameValue = (typeof GOOGLE_ANALYTICS_PARAM_NAMES)[GoogleAnalyticsParamNameKey];

export const {
    CLICK,
    GT_USER_ID,
    GT_SEND_CURRENCY,
    GT_AMOUNT_SEND_CURRENCY,
    GT_SENDING_COUNTRY_CODE,
    GT_RECEIVING_COUNTRY_CODE,
    GT_TRX_ID,
    GT_SENDER_BALID,
    GT_TRANSACTION_ID,
    GT_RECEIVING_COUNTRY,
    GT_SECTION_CLICKED,
} = GOOGLE_ANALYTICS_PARAM_NAMES;
